<div class="waiting-area-details">
  <sc-tmc-table [tableModel]="tableModel" [hideFilter]="true" (selectionChanged)="onSelectionChanged($event)" #tmcTableComponent></sc-tmc-table>
</div>
